// import React, { useState, useEffect } from 'react';
// import { useMutation, useQueryClient, useQuery } from 'react-query';
// import {
//   Box,
//   Button,
//   FormControl,
//   FormLabel,
//   Heading,
//   Select,
//   Spinner,
//   Text,
//   useToast,
//   VStack
// } from '@chakra-ui/react';
// import {
//   addPermissionToAdmin,
//   removePermissionFromAdmin,
//   getAdmins,
//   getAdminById
// } from '../../../services/adminService';
// import { getPermissions } from '../../../services/permissionService';

// const AdminPermissions = () => {
//   const queryClient = useQueryClient();
//   const toast = useToast();

//   const [selectedAdmin, setSelectedAdmin] = useState('');
//   const [selectedPermission, setSelectedPermission] = useState('');
//   const [currentPermissions, setCurrentPermissions] = useState([]);

//   const { data: admins, isLoading: adminsLoading, isError: adminsError, error: adminsErrorData } = useQuery('admins', getAdmins);
//   const { data: permissions, isLoading: permissionsLoading, isError: permissionsError, error: permissionsErrorData } = useQuery('permissions', getPermissions);

//   const fetchAdminPermissions = async (adminId) => {
//     try {
//       const admin = await getAdminById(adminId);
//       setCurrentPermissions(admin.permissions || []);
//     } catch (error) {
//       toast({
//         title: 'Error fetching admin permissions',
//         description: error.message,
//         status: 'error',
//         duration: 5000,
//         isClosable: true
//       });
//     }
//   };

//   useEffect(() => {
//     if (selectedAdmin) {
//       fetchAdminPermissions(selectedAdmin);
//     }
//   }, [selectedAdmin]);

//   const addPermissionMutation = useMutation(addPermissionToAdmin, {
//     onSuccess: () => {
//       queryClient.invalidateQueries('admins');
//       toast({
//         title: 'Permission added.',
//         status: 'success',
//         duration: 5000,
//         isClosable: true
//       });
//       fetchAdminPermissions(selectedAdmin);
//     },
//     onError: (error) => {
//       toast({
//         title: 'Error adding permission',
//         description: error.message,
//         status: 'error',
//         duration: 5000,
//         isClosable: true
//       });
//     }
//   });

//   const removePermissionMutation = useMutation(removePermissionFromAdmin, {
//     onSuccess: () => {
//       queryClient.invalidateQueries('admins');
//       toast({
//         title: 'Permission removed.',
//         status: 'success',
//         duration: 5000,
//         isClosable: true
//       });
//       fetchAdminPermissions(selectedAdmin);
//     },
//     onError: (error) => {
//       toast({
//         title: 'Error removing permission',
//         description: error.message,
//         status: 'error',
//         duration: 5000,
//         isClosable: true
//       });
//     }
//   });

//   const handleAddPermission = () => {
//     addPermissionMutation.mutate({ adminId: selectedAdmin, permissionId: selectedPermission });
//   };

//   const handleRemovePermission = (permissionId) => {
//     removePermissionMutation.mutate({ adminId: selectedAdmin, permissionId });
//   };

//   if (adminsLoading || permissionsLoading) return <Spinner />;
//   if (adminsError) return <Text>Error loading admins: {adminsErrorData.message}</Text>;
//   if (permissionsError) return <Text>Error loading permissions: {permissionsErrorData.message}</Text>;

//   return (
//     <Box>
//       <FormControl id="admin" isRequired>
//         <FormLabel>Select Admin</FormLabel>
//         <Select
//           name="admin"
//           value={selectedAdmin}
//           onChange={(e) => setSelectedAdmin(e.target.value)}
//           placeholder="Select Admin"
//         >
//           {admins.map(admin => (
//             <option key={admin._id} value={admin._id}>
//               {admin.username}
//             </option>
//           ))}
//         </Select>
//       </FormControl>
//       <FormControl id="permission" isRequired mt={4}>
//         <FormLabel>Select Permission</FormLabel>
//         <Select
//           name="permission"
//           value={selectedPermission}
//           onChange={(e) => setSelectedPermission(e.target.value)}
//           placeholder="Select Permission"
//         >
//           {permissions.map(permission => (
//             <option key={permission._id} value={permission._id}>
//               {permission.name} - {permission.method} - {permission.endpoint}
//             </option>
//           ))}
//         </Select>
//       </FormControl>
//       <Button mt={4} colorScheme="teal" onClick={handleAddPermission}>
//         Add Permission
//       </Button>
//       <VStack spacing={4} align="stretch" mt={8}>
//         {currentPermissions.map(permission => (
//           <Box key={permission._id} p={5} shadow="md" borderWidth="1px">
//             <Heading fontSize="xl">{permission.name}</Heading>
//             <Text mt={4}>Method: {permission.method}</Text>
//             <Text>Endpoint: {permission.endpoint}</Text>
//             <Button colorScheme="red" onClick={() => handleRemovePermission(permission._id)}>
//               Remove Permission
//             </Button>
//           </Box>
//         ))}
//       </VStack>
//     </Box>
//   );
// };

// export default AdminPermissions;











import React, { useState, useEffect } from 'react';
import { useMutation, useQueryClient, useQuery } from 'react-query';
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Heading,
  Select,
  Spinner,
  Text,
  useToast,
  VStack,
  CheckboxGroup,
  Checkbox
} from '@chakra-ui/react';
import {
  addPermissionsToAdmin,
  removePermissionFromAdmin,
  getAdmins,
  getAdminById
} from '../../../services/adminService';
import { getPermissions } from '../../../services/permissionService';
import CustomSpinner from '../../EndedAuctions/CustomSpinner';

const AdminPermissions = () => {
  const queryClient = useQueryClient();
  const toast = useToast();

  const [selectedAdmin, setSelectedAdmin] = useState('');
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [currentPermissions, setCurrentPermissions] = useState([]);

  const { data: admins, isLoading: adminsLoading, isError: adminsError, error: adminsErrorData } = useQuery('admins', getAdmins);
  const { data: permissions, isLoading: permissionsLoading, isError: permissionsError, error: permissionsErrorData } = useQuery('permissions', getPermissions);

  const fetchAdminPermissions = async (adminId) => {
    try {
      const admin = await getAdminById(adminId);
      setCurrentPermissions(admin.permissions || []);
    } catch (error) {
      toast({
        title: 'Error fetching admin permissions',
        description: error.message,
        status: 'error',
        duration: 5000,
        isClosable: true
      });
    }
  };

  useEffect(() => {
    if (selectedAdmin) {
      fetchAdminPermissions(selectedAdmin);
    }
  }, [selectedAdmin]);

  const addPermissionsMutation = useMutation(addPermissionsToAdmin, {
    onSuccess: () => {
      queryClient.invalidateQueries('admins');
      toast({
        title: 'Permissions added.',
        status: 'success',
        duration: 5000,
        isClosable: true
      });
      fetchAdminPermissions(selectedAdmin);
    },
    onError: (error) => {
      toast({
        title: 'Error adding permissions',
        description: error.message,
        status: 'error',
        duration: 5000,
        isClosable: true
      });
    }
  });

  const removePermissionMutation = useMutation(removePermissionFromAdmin, {
    onSuccess: () => {
      queryClient.invalidateQueries('admins');
      toast({
        title: 'Permission removed.',
        status: 'success',
        duration: 5000,
        isClosable: true
      });
      fetchAdminPermissions(selectedAdmin);
    },
    onError: (error) => {
      toast({
        title: 'Error removing permission',
        description: error.message,
        status: 'error',
        duration: 5000,
        isClosable: true
      });
    }
  });

  const handleAddPermissions = () => {
    addPermissionsMutation.mutate({ adminId: selectedAdmin, permissionIds: selectedPermissions });
  };

  const handleRemovePermission = (permissionId) => {
    removePermissionMutation.mutate({ adminId: selectedAdmin, permissionId });
  };

  if (adminsLoading || permissionsLoading) return <CustomSpinner />;
  if (adminsError) return <Text>Error loading admins: {adminsErrorData.message}</Text>;
  if (permissionsError) return <Text>Error loading permissions: {permissionsErrorData.message}</Text>;

  return (
    <Box>
      <FormControl id="admin" isRequired>
        <FormLabel>Select Admin</FormLabel>
        <Select
          name="admin"
          value={selectedAdmin}
          onChange={(e) => setSelectedAdmin(e.target.value)}
          placeholder="Select Admin"
        >
          {admins.map(admin => (
            <option key={admin._id} value={admin._id}>
              {admin.username}
            </option>
          ))}
        </Select>
      </FormControl>
      <FormControl id="permissions" isRequired mt={4}>
        <FormLabel>Select Permissions</FormLabel>
        <CheckboxGroup
          value={selectedPermissions}
          onChange={setSelectedPermissions}
        >
          {permissions.map(permission => (
            <Checkbox key={permission._id} value={permission._id}>
              {permission.name} - {permission.method} - {permission.endpoint}
            </Checkbox>
          ))}
        </CheckboxGroup>
      </FormControl>
      <Button mt={4} colorScheme="teal" onClick={handleAddPermissions}>
        Add Permissions
      </Button>
      <VStack spacing={4} align="stretch" mt={8}>
        {currentPermissions.map(permission => (
          <Box key={permission._id} p={5} shadow="md" borderWidth="1px">
            <Heading fontSize="xl">{permission.name}</Heading>
            <Text mt={4}>Method: {permission.method}</Text>
            <Text>Endpoint: {permission.endpoint}</Text>
            <Button colorScheme="red" onClick={() => handleRemovePermission(permission._id)}>
              Remove Permission
            </Button>
          </Box>
        ))}
      </VStack>
    </Box>
  );
};

export default AdminPermissions;
